import { ListItem, ListItemButton, ListItemText } from '@mui/material'
import theme from '../../theme'
import { useContext } from 'react'
import Context from '../../Context'

function Leagues({ groupName, sportName, leaguesArr }) {
  const { setCurrentLeague, setSelectedEvent, setShowSettings } = useContext(Context)

  function renderOdds(leagueName) {
    // picking anything in the menu leaves whatever screen is on top, event view or settings
    setSelectedEvent(null)
    setShowSettings(false)
    setCurrentLeague({ group: groupName, sport: sportName, league: leagueName })
  }

  return leaguesArr.map((entry) => {
    const leagueName = entry.league

    return(
      <ListItem key={`${sportName}-${leagueName}`} disablePadding>
        <ListItemButton onClick={() => renderOdds(leagueName)} sx={{ pl: 4 }}>
          <ListItemText
            sx={{ color: theme.palette.primary.contrastText }}
            primary={leagueName}
          />
        </ListItemButton>
      </ListItem>
    )
  })
}

export default Leagues
